module.exports = __webpack_public_path__ + "img/doctorImage.ba04ded0.png";